import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function SiteLayout() {
  return (
    <div className="flex flex-col min-h-screen bg-background-50">
      <ScrollToTop />
      <SiteHeader />
      <main className="flex-1 w-full">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}